import React from 'react';
import styles from './GradientLine.module.scss';
import classNames from 'classnames';

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

const GradientLine = ({ className, style }: Props) => (
  <div style={style} className={classNames(styles.root, className)} />
);

export default GradientLine;
